<template>
  <div>
    <div class="container">
      <span class="md-headline">
        Copy a case between organizations
      </span>
      <case-copy-tool />
    </div>
    <div class="container">
      <span class="md-headline">
        Show difference between two cases
      </span>
      <case-diff-tool />
    </div>
  </div>
</template>

<script>
import CaseCopyTool from '../../components/access/CaseCopyTool';
import CaseDiffTool from '../../components/access/CaseDiffTool';

export default {
  name: 'cases-management',
  components: {
    CaseCopyTool,
    CaseDiffTool,
  },
};
</script>

<style scoped>
.container {
  padding: 10px 0;
}

.md-headline {
  display: block;
  margin-bottom: 10px;
  margin-left: 16px;
}
</style>